<template lang="pug">
	#catalog(@scroll.passive='scrollTopbar( $event )')
		//- loading state
		.loading-circles(v-if='coursesLoading')
			span
			span
			span

		p.spacey.no-saved-courses(v-else-if='!displayedCourses.length') {{ view === "saved" ? "No saved courses" : "Nothing to show" }}
		.cards-container.noselect(v-else)
			CourseCard(
				v-for='course in displayedCourses'
				:key='course.id'
				:course='course'
				:saved='!!savedCourseKeys[course.id]'
				@view='viewCourse(course)'
				@save='saveCourse(course)'
				@unsave='unsaveCourse(course)'
			)

		.footer
			.view-more(@click='maxVisible += 10' v-show='courses.length > maxVisible') View More
			p.no-more.spacey(v-show='courses.length < maxVisible && displayedCourses.length !== 0') No more {{ view === "saved" ? "saved" : "" }} courses
			filters-preview(
				class="filters-preview"
				:max-visible='maxVisible'
				:filteredCourses='displayedCourses'
			)
</template>

<script>
// import { HasProperty } from '@/lib/utils';
import FiltersPreview from '@/components/FiltersPreview';
import Card from '@/components/Card';
import CourseCard from '@/components/CourseCard';

export default {
  name       : 'courses-list',
  components : {
    Card,
    CourseCard,
    FiltersPreview,
  },

  props : {
    /**
		 * Which "display" is being shown
		 */
    view : {
      type : String
    },

    courses : {
      type     : Array,
      required : true
    }
  },

  data : () => ( {
    maxVisible       : 50,
    isFiltersFromUrl : false,
  } ),

  computed : {
    coursesLoading() {
      return this.$store.getters.coursesLoading;
    },

    savedCourseKeys() {
      return this.$store.getters.savedCourseKeys;
    },

    // selectedFilters() {
    // 	return this.$store.state.selectedFilters;
    // },

    filters() {
      return this.$store.state.filters;
    },

    displayedCourses() {
      return this.courses.slice( 0, this.maxVisible );
    },
  },

  watch : {
    'selectedFilters' : {
      deep : true,
      handler( selectedFilters ) {
        if ( !Object.keys( selectedFilters ).length ) {
          return;
        }

        // This is to prevent it from firing when the selectedFilters are loaded from the url
        if ( !this.isFiltersFromUrl ) {
          this.isFiltersFromUrl = true;
          return;
        }

        this.setFiltersToUrl();
      }
    },
  },

  methods : {
    viewCourse( course ) {
      if ( !course ) return;
      this.$store.dispatch( 'openCourseInfo', course );
    },

    saveCourse( course ) {
      this.$store.dispatch( 'saveCourse', course.key );
    },

    unsaveCourse( course ) {
      this.$store.dispatch( 'unsaveCourse', course.key );
    },

    scrollTopbar( e ) {
      this.$emit( 'scroll-topbar', e );
    },

    // loadFiltersFromUrl() {
    // 	const { selectedFilters } = this;

    // 	Object.keys( selectedFilters ).forEach( ( key ) => {
    // 		const v = this.$route.query[key];
    // 		if ( !v ) {
    // 			return;
    // 		}
    // 		const isBoolean = v === 'true' || v === 'false';
    // 		const value = isBoolean ? v === 'true' : v;
    // 		const payload = {
    // 			key,
    // 			value,
    // 		};
    // 		this.$store.dispatch( 'selectFilter', payload );
    // 	} );
    // },

    // setFiltersToUrl() {
    // 	const { selectedFilters, filters } = this;

    // 	const query = filters.reduce( ( obj, filter ) => {
    // 		const { key, type } = filter;
    // 		const defaultValue = ( () => {
    // 			if ( type === 'boolean' || type === 'arbitrary' ) {
    // 				return false;
    // 			}
    // 			return filter.options[0].value;
    // 		} )();

    // 		if ( selectedFilters[key] === defaultValue ) {
    // 			return obj;
    // 		}

    // 		obj[key] = selectedFilters[key]; // eslint-disable-line
    // 		return obj;
    // 	}, {} );

    // 	this.$router.push( {
    // 		path : this.$route.path,
    // 		query,
    // 	} ).catch( () => {} );
    // }
  },

  mounted() {
    // this.loadFiltersFromUrl();
  },

  destroyed() {
    // this.$store.dispatch( 'resetFilters' );
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

#catalog {
	display: flex;
	flex-direction: column;
	overflow: auto;
	padding-top: 156px;
	transition: padding-top 0.5s ease;

	.spacey {
		margin-top: 30px;
		text-align: center;
		font-size: 16px;
		width: 100%;

		&.no-more {
			margin-top: 0;
			padding: 30px 0;
		}
	}

	.loading-circles {
		height: 50px;
		overflow: hidden;
	}

	.no-saved-courses {
		margin-top: 100px;
		text-align: center;
	}

	.cards-container {
		display: grid;
		gap: 15px;
		margin: 10px;
		margin-top: 30px;
		flex-shrink: 0;
		padding-bottom: 100px;

		@include md {
			grid-template-columns: repeat(2, 1fr);
		}

		@include xl {
			grid-template-columns: repeat(3, 1fr);
		}

		.card {
			cursor: pointer;
			transform: scale(1,1);
			transition: transform 0.2s ease;

			&.active {
				transform: scale(0.95,0.95);
			}
		}
	}

	.footer {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.view-more {
			width: 100%;
			margin: 15px;
			padding: 15px;
			border-radius: 50px;
			border: 2px solid $primary;
			font-size: 16px;
			color: $primary;
			cursor: pointer;
			text-align: center;
			margin-bottom: 50px;
		}

		.filters-preview {
			position: relative;
			// left: 50%;
			// transform: translateX(-50%);
			margin: 30px 0;
			// max-width: calc(100% - 30px);
		}
	}

}

/* Small Devices, Tablets */
@media only screen and (min-width : 1px) and (max-width : 575px) {
	#catalog {
		padding-top: 245px;
	}
}
</style>
